import React, { Component } from "react";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";
import { Growl } from "primereact/growl";
import Spinner from "../../Common/Spinner";
import axios from "axios";
import * as appConst from "../../Common/constants";

class RouteList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Routes: [],
      spinnerClass: "collapse",
      dataClass: "",
      dummy: { _id: "NA" }
    };
  }

  componentDidMount() {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          "/Route"
      )
      .then(response => {
        this.setState({ Routes: response.data });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  render() {
    return (
      <>
        <h5 align="center">Route List</h5>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="ag-theme-blue" style={{ height: "300px" }}>
            <div>
              <button
                onClick={this.onAddClick}
                className="btn btn-primary btn-sm mb-2 mr-2"
              >
                Add Route
              </button>
              <button
                onClick={this.onEditClick}
                className="btn btn-primary btn-sm mb-2"
              >
                Edit Route
              </button>
            </div>
            <AgGridReact
              rowData={this.state.Routes}
              pagination={true}
              enableSorting={true}
              enableFilter={true}
              onGridReady={params => (this.gridApi = params.api)}
              paginationAutoPageSize={true}
            >
              <AgGridColumn field="_id" hide="true" />
              <AgGridColumn
                width={50}
                checkboxSelection
                filter={false}
                resizable
              />
              <AgGridColumn
                field="name"
                headerName="Name"
                width={150}
                sortable
                resizable
                filter
              />
            </AgGridReact>
          </div>
          <Growl ref={el => (this.growl = el)} />
        </div>
      </>
    );
  }

  onAddClick = e => {
    this.props.onClick("", this.state.dummy);
  };

  onEditClick = e => {
    const selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length > 0)
      this.props.onClick("AddEdit", selectedNodes[0].data);
    else {
      this.growl.show({
        severity: "error",
        summary: "Error",
        detail: "Select Route !!"
      });
    }
  };
}

export default RouteList;
